/**
 * Design tokens read straight off the Claude Design mock
 * (~/Downloads/CDP Portal - Abridge (standalone).html).
 *
 * The mock styles layout with inline styles rather than Tailwind classes, so
 * these are the literal values it used. Keeping them in one place means the
 * screens stay a faithful transcription instead of a pile of magic hex codes.
 */
export const c = {
  /** Abridge red — primary brand accent. */
  brand: '#EA2C00',
  brandLink: '#C02907',
  /** Dark sidebar. */
  sidebar: '#151413',
  sidebarText: '#F2EBE3',
  sidebarTextMuted: 'rgba(242,235,227,0.72)',
  sidebarTextFaint: 'rgba(242,235,227,0.6)',
  sidebarTextFainter: 'rgba(242,235,227,0.4)',
  sidebarActiveBg: 'rgba(242,235,227,0.10)',
  sidebarChipBg: 'rgba(242,235,227,0.07)',
  sidebarRule: 'rgba(242,235,227,0.14)',
  sidebarAvatarBg: '#3A3532',
  /** Page canvas + surfaces. */
  canvas: '#FCF9F8',
  surface: '#FFFFFF',
  subtle: '#F9F5F1',
  border: '#F0ECEB',
  /** Text. */
  text: '#000000',
  textBody: '#423F3E',
  textMuted: '#5B5756',
  textFaint: '#726A64',
  /** Teal accent used for step/pipeline chips. */
  teal: '#002628',
  tealBg: '#E8F1F2',
  success: '#007006',
} as const;

export const shadow =
  '0 4px 6px -2px rgba(16,24,40,0.03), 0 4px 16px -4px rgba(16,24,40,0.05)';

export const font =
  'Haffer, system-ui, -apple-system, BlinkMacSystemFont, sans-serif';

export const mono = 'ui-monospace, SFMono-Regular, Menlo, monospace';

/** Shared page-content frame used by every screen in the mock. */
export const pageStyle = {
  padding: '36px 40px 56px',
  display: 'flex',
  flexDirection: 'column',
  maxWidth: 1180,
} as const;

/** The white rounded card the mock uses for tables, forms and panels. */
export const cardStyle = {
  background: c.surface,
  border: `1px solid ${c.border}`,
  borderRadius: 16,
  boxShadow: shadow,
} as const;

/** Eyebrow → h1 → lede heading block. */
export const h1Style = {
  margin: 0,
  fontSize: 32,
  lineHeight: 1.25,
  letterSpacing: '0.64px',
  fontWeight: 375,
} as const;

export const eyebrowStyle = {
  fontSize: 12,
  fontWeight: 475,
  letterSpacing: '0.06em',
  textTransform: 'uppercase',
  color: c.textMuted,
} as const;

export const ledeStyle = {
  margin: 0,
  fontSize: 16,
  lineHeight: 1.5,
  letterSpacing: '0.32px',
  fontWeight: 350,
  color: c.textBody,
  maxWidth: '62ch',
  textWrap: 'pretty',
} as const;
